import cancelBooking from '../../../../actions/siteadmin/ManualBooking/cancelBooking';

export default async function submit(values, dispatch) {
    dispatch(cancelBooking({
        bookingId: values.id,
        requestBy: values.requestBy,
        currentPage: values.currentPage,
        reason: values.reason == 'other' ? values.otherReason : values.reason,
    }));
}